import { UPDATE_PAGE_COUNTER } from '../actions/types'

export default function(state = [], action = {}) {
  switch(action.type) {
    case UPDATE_PAGE_COUNTER:
      return action.visits;
     default:
      return state
  }
}
